//      <object data="${url}" type="application/pdf"> <embed src="${url}" type="application/pdf" /> </object>

function base64PDFToBlobUrl( base64: string ) {
  const binStr = atob( base64 );
  const len = binStr.length;
  const arr = new Uint8Array(len);
  for (let i = 0; i < len; i++) {
    arr[ i ] = binStr.charCodeAt( i );
  }
  const blob =  new Blob( [ arr ], { type: 'application/pdf' } );
  const url = URL.createObjectURL( blob );
  return url;
}

export function NativePdf(props: {content:string}) {
    const { content } = props 
    const url = content ? base64PDFToBlobUrl( content ) : undefined
    return (
      content && (
        <div
          id="pdf"
          style={{
            padding: 12,
            paddingRight: 24,
            width: '70vw',
            height: '89vh',
            overflowY: 'auto',
            overflowX: 'auto',
          }}
        >
          <object data={url}  width={'100%'} height={'100%'} type="application/pdf">
            <embed src={url} type="application/pdf" />
          </object>
        </div>
      )
    )
  }